import React from 'react';
import './css/mtrusted.css';
import Start_up_Mission from '../images/Rectangle 3.png';
import kase from '../images/Rectangle 6.png';
import kdisc from '../images/Rectangle 7.png';
import kssb from '../images/Rectangle 10.png';
import kudumbashri from '../images/Rectangle 11.png';
import hoc from '../images/Rectangle 12.png';
import zdiac from '../images/Rectangle 13.png';
import liwa from '../images/Rectangle 14.png';
import clinic7 from '../images/Rectangle 107.png';
import alarz from '../images/alarz.png';
import dibba from '../images/dibba.png';
import asha from '../images/asha.png';
import at1 from '../images/liwalando.png';
import at2 from '../images/riono.png';
import at3 from '../images/rto.png';
import at4 from '../images/hitec.png';
import at5 from '../images/icon.png';
import at6 from '../images/w2s.png';
import at7 from '../images/fu.png';
import at8 from '../images/tadaang.png';

function Mtrusted() {
  return (
    <div className="container">
      <div className="mtrusted-sec-body">
      <div className="trusted-img-wrapper">
          <img src={at1} className="mtrusted-img mtbody " alt="asha" />
        </div>
        <div className="trusted-img-wrapper">
          <img src={at2} className="mtrusted-img mtbody " alt="asha" />
        </div><div className="trusted-img-wrapper">
          <img src={at3} className="mtrusted-img mtbody " alt="asha" />
        </div>
        {/* Start_up_Mission */}
        <div className="trusted-img-wrapper">
          <img src={Start_up_Mission} className="mtrusted-img mtbody " alt="Start_up_Mission" />
        </div>
        {/* kase */}
        <div className="trusted-img-wrapper">
          <img src={kase} className="mtrusted-img mtbody " alt="kase" />
        </div>
        {/* kdisc */}
        <div className="trusted-img-wrapper">
          <img src={kdisc} className="mtrusted-img mtbody " alt="kdisc" />
        </div>
        {/* kssb */}
        <div className="trusted-img-wrapper">
          <img src={kssb} className="mtrusted-img mtbody " alt="kssb" />
        </div>
        {/* kudumbashri */}
        <div className="trusted-img-wrapper">
          <img src={kudumbashri} className="mtrusted-img mtbody " alt="kudumbashri" />
        </div>
        {/* hoc */}
        <div className="trusted-img-wrapper">
          <img src={hoc} className="mtrusted-img mtbody " alt="hoc" />
        </div>
        {/* zdiac */}
        <div className="trusted-img-wrapper">
          <img src={zdiac} className="mtrusted-img mtbody " alt="zdiac" />
        </div>
        {/* liwa */}
        <div className="trusted-img-wrapper">
          <img src={liwa} className="mtrusted-img mtbody " alt="liwa" />
        </div>
        {/* clinic7 */}
        <div className="trusted-img-wrapper">
          <img src={clinic7} className="mtrusted-img mtbody " alt="clinic7" />
        </div>
        {/* alarz */}
        <div className="trusted-img-wrapper">
          <img src={alarz} className="mtrusted-img mtbody " alt="alarz" />
        </div>
        {/* dibba */}
        <div className="trusted-img-wrapper">
          <img src={dibba} className="mtrusted-img mtbody " alt="dibba" />
        </div>
        {/* asha */}
        <div className="trusted-img-wrapper">
          <img src={asha} className="mtrusted-img mtbody " alt="asha" />
        </div>
       
        
        {/* at4 */}
        <div className="trusted-img-wrapper">
          <img src={at4} className="mtrusted-img mtbody " alt="at4" />
        </div>
        {/* at5 */}
        <div className="trusted-img-wrapper">
          <img src={at5} className="mtrusted-img mtbody " alt="at5" />
        </div>
        {/* at6 */}
        <div className="trusted-img-wrapper">
          <img src={at6} className="mtrusted-img mtbody " alt="at6" />
        </div>
        {/* at7 */}
        <div className="trusted-img-wrapper at78 ">
          <img src={at7} className="mtrusted-img mtbody  " alt="at7" />
        </div>
        {/* at8 */}
        <div className="trusted-img-wrapper at87">
          <img src={at8} className="mtrusted-img mtbody" alt="at8" />
        </div>
      </div>
    </div>
  );
}

export default Mtrusted;
